import joi from 'joi';

export interface ClickPayload {
  profileId: string;
  programId: string;
  buttonId: string;
}

export const clickPayloadSchema = joi.object<ClickPayload>({
  profileId: joi.string().uuid(),
  programId: joi.string().uuid(),
  buttonId: joi.string(),
});
